export const getCDNImage = (src) => `${process.env.VUE_APP_CDN_URL}${src}`;

export const getCDNImageEncyclopedia = (src) => getCDNImage(`encyclopedia/${src}`);

export const getCDNImageAvatar = (src) => getCDNImage(src);

export const getCDNImageGeneric = (src) => getCDNImage(`images/${src}`);
